import React, { useState } from 'react'
import { Box, Typography } from '@mui/material'
import { CommonButton, CommonDialog } from '@/components/common'
import { DescriptionDialog } from '@/components/donation'
import { SubSection, StyledDemoGrid, DemoComponent } from '../styled.jsx'

export const DialogSection = () => {
  const [openBasic, setOpenBasic] = useState(false)
  const [openDesc, setOpenDesc] = useState(false)

  return (
    <>
      <SubSection
        title='Common Dialog'
        description='Base dialog with title and actions'
      >
        <StyledDemoGrid>
          <DemoComponent
            label='open basic'
            component={
              <>
                <CommonButton
                  label='Open Dialog'
                  onClick={() => setOpenBasic(true)}
                />
                <CommonDialog
                  open={openBasic}
                  onClose={() => setOpenBasic(false)}
                  title='Basic Dialog'
                  fullWidth
                  maxWidth='md'
                  actions={
                    <Box sx={{ display: 'flex', gap: 1 }}>
                      <CommonButton
                        variant='secondary'
                        onClick={() => setOpenBasic(false)}
                      >
                        Cancel
                      </CommonButton>
                      <CommonButton onClick={() => setOpenBasic(false)}>
                        Confirm
                      </CommonButton>
                    </Box>
                  }
                >
                  <Typography variant='body1' sx={{ mb: 2 }}>
                    This is a wider common dialog demonstrating typical content
                    placement. You can use it for confirmations, multi-step
                    flows, or any general purpose UI.
                  </Typography>
                  <Typography variant='body2' sx={{ mb: 1 }}>
                    Highlights:
                  </Typography>
                  <ul style={{ marginTop: 0 }}>
                    <li>
                      <Typography variant='body2'>Custom title area</Typography>
                    </li>
                    <li>
                      <Typography variant='body2'>
                        Persistent close guard
                      </Typography>
                    </li>
                    <li>
                      <Typography variant='body2'>
                        Optional actions footer
                      </Typography>
                    </li>
                  </ul>
                </CommonDialog>
              </>
            }
          />
        </StyledDemoGrid>
      </SubSection>

      <SubSection
        title='Description Dialog'
        description='All content is in the body; no footer actions'
      >
        <StyledDemoGrid>
          <DemoComponent
            label='open description'
            component={
              <>
                <CommonButton
                  label='Open Description'
                  onClick={() => setOpenDesc(true)}
                />
                <DescriptionDialog
                  open={openDesc}
                  onClose={() => setOpenDesc(false)}
                  item={{
                    title: 'Search By Sponsor Description',
                    description: [
                      'This would be text configurable by the sponsor that would display when users clicked the description button. The profile icon above should also be a configurable image',
                      'This should support links to organization websites and should show a phone number below to an event organizer like shown below.',
                      'Different procedures should support different descriptions.',
                    ],
                    phone: '(123) 456-7890',
                    website: 'https://sponsorlink.com',
                  }}
                />
              </>
            }
          />
        </StyledDemoGrid>
      </SubSection>
    </>
  )
}
